import React from 'react';
import './RexiPopup.css';

type RexiPopupProps = {
  message: string;
  onClose: () => void;
  onContinue?: () => void;
  showCancel?: boolean;
  confirmText?: string;
};

function RexiPopup(props: RexiPopupProps) {
  const { message, onClose, onContinue, showCancel, confirmText = "Got It" } = props;

  return (
    <div className="rexi-popup-overlay">
      <div className="rexi-popup-content">
        <div className="rexi-header">
          <img src="/rexi-logo.png" alt="Rexi" className="rexi-header-logo" />
          <div className="rexi-header-text">{message}</div>
        </div>

        <div className="popup-buttons">
          {showCancel ? (
            <>
              <button className="popup-nav-button secondary" onClick={onClose}>Cancel</button>
              <button className="popup-nav-button primary" onClick={onContinue}>Continue</button>
            </>
          ) : (
            <button className="popup-nav-button primary" onClick={onClose}>{confirmText}</button>
          )}
        </div>
      </div>
    </div>
  );
}

export default RexiPopup;
